module.exports = __webpack_public_path__ + "static/helvetica-neue-bold-d9dbca36b8e3ee6bd7f49028724ec507.woff";